module.exports = __webpack_public_path__ + "img/zaluzije.b6429e8e.svg";